import { useEffect, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import { ProviderInvoiceApi, ProviderInvoiceDataType } from "@/api/ProviderInvoiceApi";
import { ProviderInvoiceFormDataKeys } from "@/generated/ProviderInvoiceFormDataKeys";
import { ProviderInvoiceRelatedAttributes } from "@/formTypes/ProviderInvoiceDataType";
import ProviderInvoicePaymentForm from "@components/forms/ProviderInvoicePaymentForm";

const ProviderInvoicePaymentAddEdit = () => {
  const params = useParams()
  const { id: providerInvoicePaymentId, providerInvoiceId } = params;
  const [providerInvoice, setProviderInvoice] = useState<ProviderInvoiceDataType>({})

  useEffect(() => {
    if (providerInvoiceId) {
      const run = async (providerInvoiceId: string) => {
        const invoices = await ProviderInvoiceApi.get(providerInvoiceId, {
          selectionSet: [
            ...ProviderInvoiceFormDataKeys.filter(k => !ProviderInvoiceRelatedAttributes.includes(k)),
            "currency.*",
            "provider.*"
          ]
        });
        setProviderInvoice(invoices);
      }
      run(providerInvoiceId);
    }
  }, [providerInvoiceId]);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!providerInvoicePaymentId ? 'Agregar' : 'Editar'} Abono de Factura de Provedor`}
      backUrl={`/user/provider-invoices/payments/${providerInvoiceId}`}
      primaryActions={
        [
          {
            actionTitle: "Guardar",
            formId: "providerInvoicePaymentForm",
            type: "submit",
            color: "success"
          }
        ]}
    >
      {providerInvoice?.id && (
        <ProviderInvoicePaymentForm
          formId="providerInvoicePaymentForm"
          id={providerInvoicePaymentId}
          providerInvoice={providerInvoice}
          saveRedirectUrl={`/user/provider-invoices/payments/${providerInvoiceId}`}
        ></ProviderInvoicePaymentForm>
      )}

    </PageContainer >
  );
}

export default ProviderInvoicePaymentAddEdit;
